var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4605_6423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6557 10.8271C16.6557 14.991 13.7409 17.073 10.2765 18.2805C10.0951 18.342 9.89803 18.339 9.71853 18.2722C6.24581 17.073 3.33105 14.991 3.33105 10.8271V4.99754C3.33105 4.77667 3.41879 4.56485 3.57497 4.40867C3.73115 4.25249 3.94297 4.16475 4.16384 4.16475C5.82942 4.16475 7.91139 3.16541 9.36044 1.89957C9.53687 1.74883 9.7613 1.66602 9.99335 1.66602C10.2254 1.66602 10.4498 1.74883 10.6263 1.89957C12.0837 3.17374 14.1573 4.16475 15.8229 4.16475C16.0437 4.16475 16.2556 4.25249 16.4117 4.40867C16.5679 4.56485 16.6557 4.77667 16.6557 4.99754V10.8271Z",
    stroke: "#155DFC",
    strokeWidth: 1.66558,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4605_6423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9869,
    height: 19.9869,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldBlue);
export default __webpack_public_path__ + "static/media/shield_blue.f5de0b71034c639f1d559921e2d727b1.svg";
export { ForwardRef as ReactComponent };